var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5L0 41.6667C0 42.9927 0.526784 44.2645 1.46447 45.2022C2.40215 46.1399 3.67392 46.6667 5 46.6667H6.66667V50H10V46.6667H40V50H43.3333V46.6667H45C46.3261 46.6667 47.5979 46.1399 48.5355 45.2022C49.4732 44.2645 50 42.9927 50 41.6667V5C50 3.67392 49.4732 2.40215 48.5355 1.46447C47.5979 0.526784 46.3261 0 45 0L5 0ZM6.66667 10V20H10V10H6.66667ZM31.6667 16.6667C29.4565 16.6667 27.3369 17.5446 25.7741 19.1074C24.2113 20.6702 23.3333 22.7899 23.3333 25C23.3333 27.2101 24.2113 29.3298 25.7741 30.8926C27.3369 32.4554 29.4565 33.3333 31.6667 33.3333C33.8768 33.3333 35.9964 32.4554 37.5592 30.8926C39.122 29.3298 40 27.2101 40 25C40 22.7899 39.122 20.6702 37.5592 19.1074C35.9964 17.5446 33.8768 16.6667 31.6667 16.6667ZM6.66667 36.6667V26.6667H10V36.6667H6.66667Z",
    fill: "#123660"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.eb4eaab7a8398beda32f4d2ea699c1dd.svg";
export { ForwardRef as ReactComponent };